import {
	FETCH_MERCHANDISING,
	FETCH_MERCHANDISING_LIGHT,
	FETCH_MERCHANDISINGS,
	SET_MERCH_PRODUCTS_FILTER_BY,
	UNSET_MERCH_PRODUCTS_FILTER_BY,
	UPDATE_CURRENT_MERCH_CODE,
} from "app/pages/Merchandising/merchandisingActionTypes";
import env from "app/utils/env";
import axios from "axios";

export const fetchMerchandisings = ({ productsVisibility, shop, partnerCode }) => {
	const endpoint = env("CONTENT_API_URL") || env("BASE_URL");
	return {
		type: FETCH_MERCHANDISINGS,
		promise: axios.get(
			`${endpoint}/${productsVisibility}/${shop}/${partnerCode}/merchandisings.json`
		),
	};
};

export const fetchMerchandising = ({ code, shop, productsVisibility, partnerCode }) => {
	return {
		type: FETCH_MERCHANDISING,
		code,
		promise: fetchMerchandisingApi({ code, shop, productsVisibility, partnerCode }),
	};
};

export const fetchMerchandisingApi = ({ code, shop, productsVisibility, partnerCode }) => {
	const endpoint = env("CONTENT_API_URL") || env("BASE_URL");

	return axios.get(
		`${endpoint}/${productsVisibility}/${shop}/${partnerCode}/merchandising/${code}.json`
	);
};

export const fetchMerchandisingLight = ({ merchCode, shop, productsVisibility, partnerCode }) => {
	const endpoint = env("CONTENT_API_URL") || env("BASE_URL");
	return {
		type: FETCH_MERCHANDISING_LIGHT,
		promise: axios.get(
			`${endpoint}/${productsVisibility}/${shop}/${partnerCode}/merchandising/${merchCode}.json`
		),
	};
};

export const setMerchProductsFilter = filterBy => ({
	type: SET_MERCH_PRODUCTS_FILTER_BY,
	filterBy,
});

export const unsetMerchProductsFilter = name => {
	return {
		type: UNSET_MERCH_PRODUCTS_FILTER_BY,
		name,
	};
};

export const updateCurrentMerchCode = code => {
	return {
		type: UPDATE_CURRENT_MERCH_CODE,
		code,
	};
};
